'use client';

import { useSession } from 'next-auth/react';
import { useEffect } from 'react';

import { usePathname, useRouter } from 'next/navigation';

const SIGN_IN_PATHNAME = '/api/auth/signin';

export function useRequireLogin(redirectToUrl?: string) {
    // Don't add argument `{required: true}` because that will show the
    // "Please sign in to access this page." red banner, which looks like an
    // error but is actually not an error.
    const { data: session } = useSession();
    const router = useRouter();
    const pathname = usePathname();
    const redirectTo = redirectToUrl ?? pathname;

    useEffect(() => {
        if (!session) {
            router.push(
                `${SIGN_IN_PATHNAME}?` +
                    `callbackUrl=${encodeURIComponent(redirectTo)}`
            );
        }
    }, [redirectTo, router, session]);

    return session;
}
